import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_524'),
        permission: 'cloudaccounts_perform_sync',
        action: async (obj) => {
          await new this.$Manager('cloudaccounts').performAction({
            id: obj.cloudaccount_id,
            action: 'sync',
          })
          this.$message.success(i18n.t('scope.text_525'))
        },
        meta: (obj) => {
          const ownerDomain = this.$store.getters.isAdminMode || obj.domain_id === this.$store.getters.userInfo.projectDomainId
          let tooltip
          if (!obj.enabled_status) tooltip = i18n.t('scope.text_526')
          if (obj.enable_auto_sync) tooltip = i18n.t('scope.text_527')
          return {
            validate: (obj.enabled_status && !obj.enable_auto_sync) && ownerDomain,
            tooltip,
          }
        },
      },
      {
        label: i18n.t('scope.text_528'),
        action: async (obj) => {
          await new this.$Manager('cloudsupplier_customers').performAction({
            id: obj.id,
            action: 'sync',
          })
          this.$message.success(i18n.t('scope.text_529'))
        },
        meta: (obj) => {
          if (obj.provider.toLowerCase() === 'google') return { validate: true }
          return {
            validate: false,
            tooltip: i18n.t('scope.text_530'),
          }
        },
      },
      {
        label: i18n.t('common_29'),
        action: async (obj) => {
          this.createDialog('UpdatePaidCurrencyDialog', {
            data: [obj],
            refresh: this.refresh,
          })
        },
        meta: (obj) => {
          if (obj.billing_subscription_id) return { validate: true }
          return {
            validate: false,
          }
        },
      },
    ]
  },
}
